import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

initSentry({
    Vue,
    dsn: 'https://ed432215f988407cbc9e26e7e3f69214@o527262.ingest.sentry.io/5658865',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
